import { Trans } from '@lingui/react/macro';

import { useArticleContext } from '@/routes/Requests/contexts/ArticleContext';

import { BaseMessage } from './BaseMessage';

export const AcceptDispatchTaskMessage = () => {
  const { article, iam } = useArticleContext();

  if (!iam.hasUserScopeOnArticle('workshop')) {
    return (
      <BaseMessage
        title={
          <Trans id="article.task.accept-dispatch.on-behalf.title">
            Workshop validation required
          </Trans>
        }
        message={
          <Trans id="article.task.accept-dispatch.on-behalf.message">
            Please contact the workshop to validate the job on its behalf.
          </Trans>
        }
        article={article}
      />
    );
  }

  return (
    <BaseMessage
      title={<Trans id="article.task.accept-dispatch.title">Your expertise is required</Trans>}
      message={
        <Trans id="article.task.accept-dispatch.message">
          Please review the item details and confirm the acceptance of this job.
        </Trans>
      }
      article={article}
    />
  );
};
